import React from "react";
import VenueOccupancyBar from "./../VenueOccupancyBar";

// Components
import ClosedVenueComponent from "../../Common/ClosedVenueTag";

const VenueDetailCounter: React.FC<any> = (props: any) => {
  const occupancyPercent: number = Math.trunc(
    (props.venue.currentActivitySession?.occupancy * 100) /
      props.venue.currentActivitySession?.capacity
  );
  
  return (
    <div className="row">
      <div className="col-3 py-0 pl-2 pr-0">
        <img
          src={props.venue?.imageUrl}
          alt={props.venue?.name}
          className="mr-3 img-fluid rounded mx-auto d-block border"
        />
      </div>

      <div className="col-9">
        <span className="mb-0 small lh-125  ">
          <strong className="d-block small-title">{props.venue?.name}</strong>

          {props.venue.currentActivitySession?.isOpen && (
            <React.Fragment>
              {props.venue?.currentActivitySession?.activityName !== "" && (
                <h6 className="blue2 mb-0">
                  {props.venue.currentActivitySession.activityName}
                </h6>
              )}
              <div className="row mt-3">
                <div className="col-12 pb-2">
                  <span className="gray">
                    {" "}
                    <b className="black">{occupancyPercent}%</b> d'ocupació ({" "}
                    <b className="black">
                      {props.venue.currentActivitySession.occupancy}
                    </b>{" "}
                    /{props.venue.currentActivitySession.capacity} )
                  </span>
                  <div className="progress mt-1">
                    <VenueOccupancyBar venue={props.venue} />
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
        </span>

        {!props.venue.isPublished && 
          (props.venue.currentActivitySession == null || !props.venue.currentActivitySession.isOpen) &&
            <ClosedVenueComponent/>
        }
      </div>
    </div>
  );
};

export default VenueDetailCounter;
